import React from "react";
import {
    useAppDispatch,
    useAppSelector,
} from "tsi-common-react/src/apps/reducers";
import { setFocusedStore } from "tsi-common-react/src/apps/retail/reducers";
import {
    filteredStoreSelector,
    focusedStoreIDSelector,
} from "tsi-common-react/src/apps/retail/selectors";

import { LocatorNearestStores as LocatorNearestStoresComponent } from "../components/LocatorNearestStores";

export const LocatorNearestStores = (): React.ReactNode => {
    const stores = useAppSelector(filteredStoreSelector);
    const focusedStoreID = useAppSelector(focusedStoreIDSelector);
    const filters = useAppSelector((state) => state.retail.storeFilters);
    const dispatch = useAppDispatch();

    return (
        <LocatorNearestStoresComponent
            stores={stores}
            focusedStoreID={focusedStoreID}
            onSelectStore={(externalID) =>
                dispatch(setFocusedStore({ externalID }))
            }
            showMore={filters.limit ? true : false}
        />
    );
};
